module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('embedded-modules-component', {
    attrs: {
      "column": _vm.column,
      "state": _vm.state,
      "config": Object.assign(_vm.config, {
        showValue: false
      }),
      "embeddedModules": _vm.embeddedModules,
      "routeName": _vm.routeName,
      "row": _vm.row
    }
  }), _vm._v(" "), (_vm.row['link']) ? _c('ProductLinkComponent', {
    attrs: {
      "config": {
        linkIndex: 'link'
      },
      "row": _vm.row,
      "column": _vm.column,
      "title": 'Your product identifying data'
    }
  }) : [_c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t('Your product identifying data')),
      expression: "t('Your product identifying data')",
      arg: "tooltip"
    }],
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.row['name']))]), _vm._v(" "), _c('br')], _vm._v(" "), (_vm.row['shop_code']) ? [_c('span', {
    staticClass: "details"
  }, [_c('strong', {
    staticClass: "details"
  }, [_vm._v("Index: ")]), _vm._v("\n            " + _vm._s(_vm.row['shop_code']) + "\n        ")])] : _vm._e(), _vm._v(" "), (_vm.row['ean']) ? [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "details"
  }, [_c('strong', [_vm._v("EAN: ")]), _vm._v(_vm._s(_vm.row['ean']) + "\n        ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81aaf250!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/PrimaryProductDetailComponent.vue
// module id = 1334
// module chunks = 2